// extracted by mini-css-extract-plugin
export default {"address":"g__address--xd3t8"};